import styled from 'styled-components'

import GlobalStyles from '../../../../components/component-items/styles'

export const Tooltip = styled(GlobalStyles.Tooltip)`
  flex: 0 0 3rem;

  button {
    &:disabled {
      cursor: not-allowed;
      opacity: 0.45;
    }
  }

  &:before {
    width: 100px;
    left: 50%;
    transform: translate(-50%, 0);
  }
`
